import React, { useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { AuthGuard } from "../App";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTools, faPaperPlane, faTimesCircle } from "@fortawesome/free-solid-svg-icons"; // Added icons

const AddMaintenanceRequest = () => {
  const [requestContent, setRequestContent] = useState("");
  const navigate = useNavigate();
  const token = localStorage.getItem("token");
  const userDataString = localStorage.getItem("user");
  const userData = JSON.parse(userDataString);
  const userId = userData.unique;
  const propertyId = localStorage.getItem("specificPropertyId");

  const handleSubmit = async (e) => {
    e.preventDefault(); // Prevent default form submission behavior

    if (!requestContent.trim()) {
      toast.error("Maintenance request cannot be empty.");
      return;
    }
    if (!propertyId || !userId) {
        toast.error("Missing property or user ID. Cannot submit request.");
        navigate("/user/myapartment"); // Redirect to a safe page
        return;
    }


    try {
      const response = await axios.post(
        `https://backend.inyumba.co.ke/iNyumba/maintenance/properties/${propertyId}/users/${userId}/maintenance-requests`,
        {
          request_content: requestContent,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );

      toast.success(response.data.response);
      navigate("/user/myapartment"); // Navigate after successful submission
    } catch (error) {
      console.error("Error adding maintenance request:", error);
      if (error.response && error.response.data && error.response.data.response) {
        toast.error(error.response.data.response);
      } else {
        toast.error("An unexpected error occurred. Please try again.");
      }
    }
  };

  const handleCancel = () => {
    navigate("/user/myapartment");
  };

  return (
    <AuthGuard>
      <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-blue-50 to-indigo-100 p-4 sm:p-6 lg:p-8">
        
        <div className="max-w-2xl w-full bg-white rounded-2xl shadow-xl hover:shadow-2xl transition-shadow duration-300 p-8 text-center space-y-8 animate-fade-in-down">
          <div className="text-center">
            <FontAwesomeIcon icon={faTools} className="text-indigo-500 text-6xl mx-auto mb-4" />
            <h1 className="text-4xl font-extrabold text-gray-900 mb-2">
              Submit a Maintenance Request
            </h1>
            <p className="text-gray-600 text-lg">
              Tell us what needs fixing in your property.
            </p>
          </div>

          <form className="space-y-6" onSubmit={handleSubmit}>
            <div>
              <label
                className="block text-gray-700 text-lg font-semibold mb-2 text-left"
                htmlFor="request-content"
              >
                What needs fixing?
              </label>
              <textarea
                id="request-content"
                className="block w-full py-3 px-4 border-2 border-gray-200 rounded-xl placeholder-gray-500 text-gray-900 focus:outline-none focus:ring-indigo-400 focus:border-indigo-400 sm:text-lg transition-all duration-200 resize-y"
                rows="6"
                placeholder="e.g., Leaky faucet in the kitchen, broken window in the living room, clogged drain in the bathroom, etc."
                value={requestContent}
                onChange={(e) => setRequestContent(e.target.value)}
              ></textarea>
            </div>

            <div className="flex justify-end space-x-4 pt-4">
              <button
                className="flex items-center space-x-2 bg-gray-200 text-gray-800 hover:bg-gray-300 px-6 py-3 rounded-lg font-semibold text-lg shadow-sm transition-all duration-200 transform hover:scale-105 focus:outline-none focus:ring-2 focus:ring-gray-400 focus:ring-offset-2"
                type="button"
                onClick={handleCancel}
              >
                <FontAwesomeIcon icon={faTimesCircle} />
                <span>Cancel</span>
              </button>
              <button
                className="flex items-center space-x-2 bg-gradient-to-r from-green-500 to-emerald-600 text-white hover:from-green-600 hover:to-emerald-700 px-6 py-3 rounded-lg font-semibold text-lg shadow-md transition-all duration-200 transform hover:scale-105 focus:outline-none focus:ring-2 focus:ring-green-500 focus:ring-offset-2"
                type="submit" // Changed to type="submit" to utilize form's onSubmit
              >
                <FontAwesomeIcon icon={faPaperPlane} />
                <span>Submit Request</span>
              </button>
            </div>
          </form>
        </div>
      </div>
    </AuthGuard>
  );
};

export default AddMaintenanceRequest;